import { render, staticRenderFns } from "./cliente.unidades.vue?vue&type=template&id=32a87104&"
import script from "./cliente.unidades.vue?vue&type=script&lang=js&"
export * from "./cliente.unidades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports